<template>
  <div></div>
</template>
<script>
export default {
  name: "KANBAN",
};
</script>
